// Pagination.tsx
import React from "react";
// ASSETS

// STYLES
import { PaginationWrapper, PageNumber, Dots } from "./PaginationStyled";

// LIBRARIES

// MISC
import { IProps } from "./PaginationModel";
import { TextType } from "../CustomText/CustomTextModel";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "../CustomText/CustomText";

const Pagination: React.FC<IProps> = ({
  totalPages = 0,
  currentPage = 0,
  onPageChange = () => { },
}) => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  // STATE CONSTANTS

  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        i === currentPage ||
        i === currentPage - 1 ||
        i === currentPage + 1
      ) {
        pages.push(
          <PageNumber
            key={i}
            active={i === currentPage}
            onClick={() => onPageChange(i)}
            biggerCursor={biggerCursor}
          >
            <CustomText text={i} type={TextType.H5} />
          </PageNumber>
        );
      } else if (i === currentPage - 2 || i === currentPage + 2) {
        pages.push(<Dots key={i}>...</Dots>);
      }
    }
    return pages;
  };

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return <PaginationWrapper>{renderPageNumbers()}</PaginationWrapper>;
};

export default Pagination;
